<template>
  <svg width="100" viewBox="0 0 450 450" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="loadingsvg-items">
      <!-- 三角 -->
      <path opacity="0" id="loadingsvg-triangle" d="M219.1 77.6H373.3V231.8L219.1 77.6Z" stroke="black" stroke-width="6" stroke-miterlimit="10"/>
      <!-- 圆1 -->
      <path opacity="0" id="loadingsvg-circle1" d="M72 142C72 160.565 79.375 178.37 92.5022 191.498C105.63 204.625 123.435 212 142 212C160.565 212 178.37 204.625 191.498 191.498C204.625 178.37 212 160.565 212 142C212 123.435 204.625 105.63 191.498 92.5026C178.37 79.3749 160.565 72 142 72C123.435 72 105.63 79.3749 92.5022 92.5026C79.375 105.63 72 123.435 72 142Z" fill="none" stroke="#000000" stroke-width="6"></path>
      <!-- 正方形 -->
      <path opacity="0" id="loadingsvg-square" stroke-width="6" fill="none" stroke="#000000" d="M207 374H77V244H207V374Z"></path>
      <!-- 圆2 -->
      <ellipse opacity="0" id="loadingsvg-circle2" cx="308.4" cy="308.3" rx="70" ry="70" stroke="black" stroke-width="6"/>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'loadingSvg',
  mounted () {
    this.animation()
  },
  methods: {
    animation () {
      setTimeout(() => {
        var anime = this.$anime
        var that = this
        var triangle = document.getElementById('loadingsvg-triangle')
        var circle1 = document.getElementById('loadingsvg-circle1')
        var circle2 = document.getElementById('loadingsvg-circle2')
        var square = document.getElementById('loadingsvg-square')
        var items = document.getElementById('loadingsvg-items')
        // var triangleTimeLine = anime.timeline({
        //   targets: [triangle, circle2, circle1, square],
        //   duration: 500,
        //   easing: 'linear'
        // })
        // triangleTimeLine.add({
        //   strokeDashoffset: [anime.setDashoffset, 0],
        //   easing: 'easeInOutSine',
        //   duration: 1500,
        //   direction: 'alternate',
        //   loop: true
        // })
        anime({
          targets: [triangle, circle2, circle1, square],
          duration: 1,
          opacity: [0, 1]
        })
        anime({
          targets: triangle,
          duration: 3000,
          easing: 'cubicBezier(.3, .5, .3, .01)',
          strokeDashoffset: [anime.setDashoffset, 0],
          delay: 1
        })
        anime({
          targets: circle2,
          duration: 3000,
          easing: 'cubicBezier(.3, .5, .3, .01)',
          strokeDashoffset: [anime.setDashoffset, 0],
          delay: 1
        })
        // var circle1Length = anime.setDashoffset(circle1)
        anime({
          targets: circle1,
          duration: 3000,
          easing: 'cubicBezier(.3, .5, .3, .01)',
          strokeDashoffset: [anime.setDashoffset, 0],
          delay: 1
        })
        anime({
          targets: square,
          duration: 3000,
          easing: 'cubicBezier(.3, .5, .3, .01)',
          strokeDashoffset: [anime.setDashoffset, 0],
          delay: 1
        })
        anime({
          complete: function (val) {
            that.$emit('finishCallback')
          },
          targets: [triangle, circle2, circle1, square],
          delay: 3300,
          fill: '#000',
          easing: 'easeInExpo',
          duration: 200,
          endDelay: 800
        })
        anime({
          targets: items,
          opacity: [1, 0],
          duration: 600,
          easing: 'easeInOutQuad',
          delay: 4000
        })
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/compos/loadingSvg.vue